import React from "react";
import MediaQuery from "theme/components/helpers/MediaQuery";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import LayeredNavigation from "theme/modules/Layer/LayeredNavigation";
import LabelledIcon from "theme/components/molecules/LabelledIcon";
import Button from "theme/components/atoms/Button";
import Modal from "theme/components/organisms/Modal";

const LayerRelatedHeader = ({ isLayerActive, toggleFilters }) => {
  if (!isLayerActive) {
    return null;
  }
  return (
    <MediaQuery maxWidth={1500 - 1}>
      <div className="layer-related__filters">
        <Button appearance="link" onClick={toggleFilters}>
          <LabelledIcon appearance="vertical" icon="list" title="Show filters">
            <FormattedMessage
              id="modules.Layer.LayerRelated.filters"
              defaultMessage="Filters list"
            />
          </LabelledIcon>
        </Button>
      </div>
    </MediaQuery>
  );
};

LayerRelatedHeader.propTypes = {
  isLayerActive: PropTypes.bool,
  toggleFilters: PropTypes.func.isRequired,
};

const LayerRelated = ({
  isLayerActive,
  layer,
  location,
  activeFilters,
  toggleFilters,
}) => {
  if (!isLayerActive) {
    return null;
  }
  return (
    <div>
      <MediaQuery maxWidth={1500 - 1}>
        {(matches) =>
          matches ? (
            <Modal
              isOpen={activeFilters}
              onRequestClose={() => toggleFilters(false)}
              extraClass="filters__modal"
            >
              <span className="modal__title">
                <FormattedMessage
                  id="modules.Layer.LayerRelated.filter"
                  defaultMessage="Filter"
                />
              </span>
              <LayeredNavigation layer={layer} location={location} />
              <div className="layer-related__navigation__actions">
                <Button
                  appearance="primary"
                  onClick={() => toggleFilters(false)}
                >
                  <FormattedMessage
                    id="theme.modules.Layer.LayerRelated.Apply"
                    defaultMessage="Apply"
                  />
                </Button>
              </div>
            </Modal>
          ) : (
            <div className="layer-related__navigation">
              <LayeredNavigation layer={layer} location={location} />
            </div>
          )
        }
      </MediaQuery>
    </div>
  );
};

LayerRelated.propTypes = {
  ...LayeredNavigation.propTypes,
  isLayerActive: PropTypes.bool,
  activeFilters: PropTypes.bool,
};

export { LayerRelatedHeader, LayerRelated };
